// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import { ExpandedEntryJSON } from "../../../src/apidefs";
import { RLink } from "./RLink";
import { EntryList } from "./EntryList";
import { CompoJSON } from "../models/compos";
import { MusicalNoteIcon } from "@heroicons/react/24/solid";
import { UpcomingCard } from "./UpcomingCard";

export const CompoCard = (props: {
  compo: CompoJSON;
  badge?: {
    link: string;
    text: JSX.Element;
    className: string;
  };
  small?: boolean;
  entries?: ExpandedEntryJSON[];
  entryCount?: number;
}) => {
  const { compo, entries, badge, entryCount } = props;

  // Sidebar variant (no entries) - compact card
  if (!entries) {
    return (
      <UpcomingCard
        to={
          badge
            ? "/compo/" + compo.id + badge.link
            : "/compo/" + compo.id + "/results"
        }
        image={compo.primary_image}
        imageAlt={compo.name}
        title={compo.name}
        subtitle={badge ? badge.text : new Date(compo.stop).toDateString()}
      />
    );
  }

  // Full variant with entries - used on All Compos page
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200/60 bg-white shadow-sm dark:border-white/10 dark:bg-slate-800/80">
      <RLink to={"/compo/" + compo.id + "/results"} variant="unstyled">
        <div className="flex items-center gap-3 rounded-t-2xl bg-slate-50 p-5 ring-inset transition-all hover:ring-2 hover:ring-blue-400/50 dark:bg-slate-700/50 dark:hover:ring-blue-500/50">
          <img
            className="h-14 w-14 flex-none rounded-full object-cover shadow-sm ring-2 ring-white dark:ring-slate-600"
            src={compo.primary_image}
            alt={compo.name}
          />

          <div className="flex-1">
            <div className="text-lg font-bold text-slate-900 dark:text-white">
              {compo.name}
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
              <span>{new Date(compo.stop).toDateString()}</span>
              {entryCount !== undefined && (
                <>
                  <span className="text-slate-300 dark:text-slate-600">|</span>
                  <span className="flex items-center gap-1">
                    <MusicalNoteIcon className="h-3.5 w-3.5" />
                    {entryCount} {entryCount === 1 ? "entry" : "entries"}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </RLink>

      <div className="p-5 pt-3">
        <EntryList
          entries={entries}
          hideStats
          hidePlayAll
          hideFilter
          avatar_urls={entries.map((x: ExpandedEntryJSON) =>
            [
              x.avatar_url_1,
              x.avatar_url_2,
              x.avatar_url_3,
              x.avatar_url_4,
              x.avatar_url_5,
            ].filter((url) => !!url)
          )}
        />
      </div>
    </div>
  );
};
